import { PCUSTOMProject_State } from '@batical/types/src'
import ProjetCommonReducer from '@batical/types/src/ProjectCommonState'

const PCUSTOM: PCUSTOMProject_State = {
  calcul_code: 'PCUSTOM',
  bati_version: 1,
  saveDate: 0,
  deleted: 0,
  id: '',
  name: '',
  savedAt: 0,
  createdAt: 0,
  calculs: {},
  ...ProjetCommonReducer
}

export default PCUSTOM
